/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react'
import { languageList, useTranslation } from '@pancakeswap/localization'
import {
  footerLinks,
  Menu as UikitMenu,
  NextLinkFromReactRouter,
  useModal,
  useMatchBreakpoints,
} from '@pancakeswap/uikit'
import { useBoolean } from 'ahooks'
import { slide as BurgerMenu } from 'react-burger-menu'
import { useIsMounted } from '@pancakeswap/hooks'
import USCitizenConfirmModal from 'components/Modal/USCitizenConfirmModal'
import { NetworkSwitcher } from 'components/NetworkSwitcher'
import { useCakeBusdPrice } from 'hooks/useBUSDPrice'
import useTheme from 'hooks/useTheme'
import { useRouter } from 'next/router'
import { useMemo, useEffect, useState, useRef } from 'react'
import throttle from 'lodash/throttle'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { IdType } from 'hooks/useUserIsUsCitizenAcknowledgement'
import NextLink from 'next/link'
import styled from 'styled-components'
import GlobalSettings from './GlobalSettings'
import { SettingsMode } from './GlobalSettings/types'
import { useMenuItems } from './hooks/useMenuItems'
import UserMenu from './UserMenu'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'
// import { MenuContext } from '@pancakeswap/uikit/src/widgets/Menu/context'
import SettingsModal from './GlobalSettings/SettingsModal'
import { Button, Dropdown } from '../../componentsNew'
// import BottomNav from '../../../../../packages/uikit/src/components/BottomNav'

const Nav = styled.div`
  transition: all 0.3s ease-in-out;
  @media not screen and (max-width: 1280px) {
    position: fixed;
    inset: 0 0 auto 0;
    /* height: 64px; */
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(10px);
    z-index: 31;
    .internal {
      margin: 0 auto;
      /* max-width: 1200px; */
      padding: 0 64px;
      /* height: 100%; */
      height: 64px;
    }
    .divider {
      position: absolute;
      bottom: 0;
      margin: 0;
      border: none;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.08);
    }
    .logo {
      margin-right: 72px;
      gap: 8px;
      div {
        width: 48px;
        height: 48px;
      }
      h2 {
        /* padding-right: 1rem;
        font-size: 16px;
        font-style: italic;
        font-weight: 900;
        text-transform: uppercase;
        background: linear-gradient(135deg, #ffe2b0 0%, #efb54f 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; */

        /* padding-right: 1rem; */
        color: var(---, #f4c470);
        text-align: center;
        font-size: 24px;
        font-style: italic;
        font-weight: 700;
        line-height: 100%;
        text-transform: uppercase;
      }
    }
    nav {
      flex: 1;
      gap: 24px;
      height: inherit;
      .jump-link {
        height: inherit;
        font-size: 16px;
        font-weight: 700;
        line-height: 56px;
        user-select: none;
        transition: all 0.3s ease-in-out;
        /* z-index: 1; */
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
      }
      .active {
        color: #f4c470;
        border-bottom-color: #f4c470;
      }
      .default {
        color: rgba(255, 255, 255, 1);
        &:hover {
          opacity: 0.6;
        }
      }
      .item {
        cursor: pointer;
        svg {
          margin-left: 2px;
          width: 12px;
          height: 12px;
          transition: all 0.3s ease-in-out;
        }
      }
      .open {
        svg {
          fill: rgba(242, 75, 67, 1);
          transform: rotate(180deg);
        }
      }
      .hide {
        svg {
          fill: rgba(255, 255, 255, 1);
        }
      }
      .hot {
        position: relative;
        margin-right: 32px;
        span {
          -webkit-text-fill-color: white;
          position: absolute;
          top: 11px;
          right: -30px;
          padding: 0 6px 1px 6px;
          height: 16px;
          border-radius: 10px;
          background: #f24943;
          color: #fff;
          font-size: 12px;
          font-weight: 600;
          z-index: 1;
        }
      }
    }
    .item-menu {
      padding: 0px 40px;
      gap: 24px;
      height: 68px;
      border-top: 1px solid rgba(244, 196, 112, 0.12);
      /* border-bottom: 1px solid rgba(244, 196, 112, 0.12); */
      background: rgba(255, 255, 255, 0.04);
      a {
        height: inherit;
        font-size: 16px;
        font-weight: 700;
        line-height: 64px;
        user-select: none;
        transition: all 0.3s ease-in-out;
        z-index: 1;
      }
      img {
        width: 18px;
        height: 18px;
      }
      .active {
        background: linear-gradient(93.23deg, #ffe2b0 0%, #efb54f 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      .default {
        color: rgba(255, 255, 255, 1);
        &:hover {
          opacity: 0.6;
        }
      }
    }
    .more {
      height: inherit;
      .language,
      .settings {
        height: inherit;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          opacity: 0.6;
        }
      }
      .language + .settings {
        margin-left: 16px;
      }
      .divide {
        margin: 0 24px;
        border: none;
        width: 1px;
        height: 16px;
        background: rgba(255, 255, 255, 0.25);
      }
    }
    /* mobile */
    &.mobile-nav {
      display: none;
    }
  }
  @media screen and (max-width: 1280px) {
    position: sticky;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 100;
    /* desktop */
    &.desktop-nav {
      display: none;
    }
    &.mobile-nav {
      z-index: 100;
      backdrop-filter: blur(5px);
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      width: 100%;
      padding: 8px 15px;

      .logo {
        /* margin-right: 72px; */
        gap: 4px;
        div {
          width: 32px;
          height: 32px;
        }
        h2 {
          color: var(---, #f4c470);
          text-align: center;
          font-size: 16px;
          font-style: italic;
          font-weight: 700;
          line-height: 100%;
          text-transform: uppercase;
        }
      }

      /* .right {
        img {
          width: 16px;
          height: 16px;
        }
      } */

      .active {
        color: #f4c470;
      }

      .bm-burger-button {
        position: relative;
      }
      .bm-overlay {
        left: 0;
        height: 100vh !important;
      }
      .bm-menu-wrap {
        height: 100vh !important;
      }
      a {
        color: #fff;
      }
      .flex-1 {
        flex: 1;
      }

      .divide {
        height: 13px;
        width: 1px;
        opacity: 0.1;
        background: #fff;
      }

      .f-14 {
        color: var(--neutral-color-white-100-primary-text, #fff);
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%; /* 14px */
      }

      .w-full {
        width: 100%;
      }
      .flex {
        display: flex;
      }
      .flex-col {
        flex-direction: column;
      }
      .items-center {
        align-items: center;
      }
      .justify-between {
        justify-content: space-between;
      }
      .justify-center {
        justify-content: center;
      }
      .gap-44 {
        gap: 28px;
      }
      .gap-8 {
        gap: 8px;
      }
      .gap-12 {
        gap: 12px;
      }

      .setting-button {
        margin-left: auto;
        width: 122px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.12);
      }
    }
    .logo {
      gap: 8px;
      /* margin-left: -4px; */
      div {
        width: 48px;
        height: 48px;
      }
      h2 {
        /* padding-right: 1rem;
        font-size: 16px;
        font-style: italic;
        font-weight: 900;
        text-transform: uppercase;
        background: linear-gradient(135deg, #ffe2b0 0%, #efb54f 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; */

        color: var(---, #f4c470);
        text-align: center;
        font-size: 16px;
        font-style: italic;
        font-weight: 900;
        line-height: 100%;
        text-transform: uppercase;
      }
    }
    .close {
      margin-right: -12px;
      width: 40px;
      height: 40px;
      z-index: 3;
      svg {
        transform: scale(1.2);
      }
    }
  }
  .scroll-box {
    overflow-y: auto;
  }
  .link {
    .jump {
      height: 52px;
      color: #fff;
      font-size: 14px;
      font-weight: 700;
    }
    svg {
      margin-left: 2px;
      width: 12px;
      height: 12px;
      transition: all 0.3s ease-in-out;
    }
    .open {
      fill: #f4c470;
      transform: rotate(180deg);
    }
    .hide {
      fill: rgba(255, 255, 255, 1);
    }
    .hot {
      position: relative;
      margin-right: 32px;
      span {
        -webkit-text-fill-color: white;
        position: absolute;
        top: 12px;
        left: 56px;
        padding: 0 6px 1px 6px;
        height: 16px;
        border-radius: 10px;
        background: #f24943;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        transform: scale(0.8);
        z-index: 1;
      }
    }
  }
  .item-menu {
    a {
      padding: 0 16px;
      height: 52px;
      color: #fff;
      font-size: 14px;
      font-weight: 700;
    }
  }
  .more {
    .language,
    .settings {
      img {
        min-width: 24px;
        height: 24px;
      }
    }
  }
`

const DropDownLanguage = styled.div`
  margin-top: 2px;
  padding: 8px;
  width: 160px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(41, 41, 41, 0.8);
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.16);
  backdrop-filter: blur(6px);
  p {
    height: 32px;
    padding: 0px 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 32px;
    user-select: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }
  .active {
    border-radius: 8px;
    background: rgba(51, 51, 51, 1);
    color: rgba(244, 196, 112, 1);
  }
  .default {
    color: rgba(255, 255, 255, 1);
    &:hover {
      opacity: 0.6;
    }
  }
`

const Wrapper = styled.div<{ $open: boolean }>`
  @media not screen and (max-width: 1280px) {
    /* padding-top: 64px; */
    padding-top: ${({ $open }) => ($open ? '64px' : '132px')};
    overflow: hidden;
    .circular {
      position: absolute;
      top: -495px;
      right: -492px;
      width: 1213px;
      height: 1213px;
      border-radius: 50%;
      opacity: 0.16;
      background: radial-gradient(887.84% 70.71% at 50% 50%, #ff3e33 0%, #ffb493 100%);
      filter: blur(400px);
      pointer-events: none;
      z-index: 21;
    }
  }
  @media screen and (max-width: 1280px) {
  }
`

export const IconNavArrow: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M6.79959 8.625C6.39979 9.125 5.60021 9.125 5.20041 8.625L2.70171 5.5C2.20754 4.88197 2.67768 4 3.5013 4L8.4987 4C9.32232 4 9.79246 4.88197 9.29829 5.5L6.79959 8.625Z" />
    </svg>
  )
}

export const MENU_HEIGHT = 64
export const MOBILE_MENU_HEIGHT = 44
export const TOP_BANNER_HEIGHT = 70
export const TOP_BANNER_HEIGHT_MOBILE = 84

const LinkComponent = (linkProps) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

const styles = {
  bmMenuWrap: {
    // top: '82px',
    // width: '100%',
    backgroundColor: '#1f1f1f',
    // height: '100vh!important',
    // position: 'absolute',
    // height: '100vh',
    left: 0,
    top: 0,
    // paddingTop: '82px',
    // height: 'calc(100vh - 81px)',
    // overflow: 'hidden',
    // transform: 'translate3d(100%, 0px, 0px)',
  },
  bmItemList: {
    padding: '22px 32px',
    // display: 'flex',
    // flexDirection: 'column',
    // gap: '12px',
  },
  bmItem: {
    height: '100%',
    display: 'flex',
  },
}

const Menu = (props) => {
  const router = useRouter()
  const { chainId } = useActiveChainId()
  const { isDark, setTheme } = useTheme()
  const cakePriceUsd = useCakeBusdPrice({ forceMainnet: true })
  const { currentLanguage, setLanguage, t } = useTranslation()

  const { pathname } = useRouter()
  const [onUSCitizenModalPresent] = useModal(
    <USCitizenConfirmModal title={t('Agni Perpetuals')} id={IdType.PERPETUALS} />,
    true,
    false,
    'usCitizenConfirmModal',
  )

  const menuItems = useMenuItems(onUSCitizenModalPresent)

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  const getFooterLinks = useMemo(() => {
    return footerLinks(t)
  }, [t])

  const [onPresentSettingsModal] = useModal(<SettingsModal mode={SettingsMode.GLOBAL} onlySetting />)

  const { isMobile } = useMatchBreakpoints()
  const isMounted = useIsMounted()

  const refPrevOffset = useRef(typeof window === 'undefined' ? 0 : window.scrollY)
  const [showMenu, setShowMenu] = useState(true)
  const topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT
  const totalTopMenuHeight = isMounted && null ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT

  useEffect(() => {
    const handleScroll = () => {
      const currentOffset = window.scrollY
      const isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight
      const isTopOfPage = currentOffset === 0
      // Always show the menu when user reach the top
      if (isTopOfPage) {
        setShowMenu(true)
      }
      // Avoid triggering anything at the bottom because of layout shift
      else if (!isBottomOfPage) {
        if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
          // Has scroll up
          setShowMenu(true)
        } else {
          // Has scroll down
          setShowMenu(false)
        }
      }
      refPrevOffset.current = currentOffset
    }
    const throttledHandleScroll = throttle(handleScroll, 200)

    window.addEventListener('scroll', throttledHandleScroll)
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll)
    }
  }, [totalTopMenuHeight])

  const [opened, { setTrue, setFalse }] = useBoolean(false)

  const showSetting = () => {
    onPresentSettingsModal()
  }

  const [openMenu, setOpenMenu] = useState<number>(-1)

  const filterMenuIndex = useMemo(() => {
    const index = menuItems.findIndex(({ href }) => pathname.startsWith(href))
    return index !== -1 && menuItems[index].items.length > 0 ? index : -1
  }, [menuItems, pathname])

  useEffect(() => {
    setOpenMenu(filterMenuIndex)
  }, [filterMenuIndex])

  // 检查URL参数和sessionStorage中的nav参数
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search)
      const navParam = urlParams.get('nav')

      if (navParam === 'hide') {
        sessionStorage.setItem('nav', 'hide')
      }
    }
  }, [])

  // 如果sessionStorage中nav为hide，则不渲染菜单
  if (typeof window !== 'undefined' && sessionStorage.getItem('nav') === 'hide') {
    return <>{props.children}</>
  }

  return (
    <>
      {/* desktop */}
      <Nav className="desktop-nav" style={{ transform: `translateY(${showMenu ? '0' : '-100%'})` }}>
        <div className="internal flex flex-row items-center justify-between">
          <NextLink className="logo flex flex-row items-center justify-start" href="/">
            <div className="row-center">
              <img src="/newImages/home/logo.png" alt="icon" />
            </div>
            <h2>Perpstreet</h2>
          </NextLink>
          <nav className="flex flex-row items-center justify-start">
            {menuItems.map((ele, index) => (
              <div key={ele.label}>
                {ele.items.length === 0 ? (
                  <NextLink
                    className={`jump-link row-start ${activeMenuItem?.href === ele?.href ? 'active' : 'default'} ${
                      ele.href === '/liquidity' ? 'hot' : ''
                    }`}
                    href={ele.href}
                    // href={ele.items.length === 0 ? ele.href : `${ele.href}${ele.items[0].href}`}
                    onClick={() => {
                      setOpenMenu(-1)
                    }}
                  >
                    {t(ele.label)}
                    {ele.href === '/liquidity' && <span className="row-center">hot</span>}
                  </NextLink>
                ) : (
                  <div
                    className={`jump-link item row-start ${openMenu === index ? 'open active' : 'hide default'}`}
                    onClick={() => {
                      setOpenMenu(index)
                      router.push(`${ele.items[0].href}`)
                    }}
                  >
                    {t(ele.label)}
                    {ele.items.length > 0 && <IconNavArrow />}
                  </div>
                )}
              </div>
            ))}
          </nav>
          <div className="more flex flex-row items-center justify-end">
            {/* <Dropdown
              overlay={
                <div className="language flex flex-col items-center justify-center">
                  <img src="/newImages/_global/icon-mainnet.svg" alt="icon" />
                </div>
              }
            >
              <DropDownLanguage>
                {languageList.map((ele) => (
                  <p
                    className={`${currentLanguage.code === ele.code ? 'active' : 'default'}`}
                    key={ele.code}
                    onClick={() => setLanguage(ele)}
                    aria-hidden
                  >
                    {ele.language}
                  </p>
                ))}
              </DropDownLanguage>
            </Dropdown> */}
            {/* <div className="settings flex flex-col items-center justify-center">
              <img src="/newImages/_global/icon-settings.svg" alt="icon" onClick={onPresentSettingsModal} aria-hidden />
            </div> */}
            <NetworkSwitcher />
            <hr className="divide" />
            <UserMenu />
          </div>
        </div>
        {openMenu !== -1 && (
          <div className="item-menu row-center">
            {menuItems[openMenu].items.map((ele) => (
              <NextLink
                className={`row-start ${pathname === ele.href ? 'active' : 'default'}`}
                href={ele.href}
                key={ele.href}
                target={/^http/.test(ele.href) ? '_blank' : '_self'}
              >
                {t(ele.label as string)}
                {/^http/.test(ele.href) && <img src="/newImages/_global/icon-jump.svg" alt="icon" />}
              </NextLink>
            ))}
          </div>
        )}
        <hr className="divider" />
      </Nav>
      {/* mobile */}
      <Nav className="mobile-nav" style={{ width: '100%' }}>
        {/* <BottomNav items={menuItems} activeItem={activeMenuItem?.href} /> */}
        <div className="flex gap-12 justify-between items-center w-full">
          {/* <img src="/newImages/_global/icon-logo.svg" alt="icon" /> */}
          <NextLink className="logo flex flex-row items-center justify-start" href="/">
            <div className="row-center">
              <img src="/newImages/home/logo.png" alt="icon" />
            </div>
            <h2>Perpstreet</h2>
          </NextLink>
          <div className="right flex items-center gap-12">
            <NetworkSwitcher iconMode />
            <UserMenu />
            <hr className="divide" />
            <BurgerMenu
              onStateChange={(state) => {
                if (state.isOpen) return
                setFalse()
              }}
              styles={styles as any}
              isOpen={opened}
              customBurgerIcon={
                <div onClick={setTrue}>
                  <img
                    alt="icon"
                    style={{ width: '24px', height: '24px', position: 'relative', zIndex: '3' }}
                    src="/newImages/_global/hamburger.svg"
                  />
                </div>
              }
            >
              <div className="flex flex-col gap-44">
                <div className="flex flex-row items-center justify-between">
                  <NextLink className="logo flex flex-row items-center justify-start" href="/">
                    <div className="row-center">
                      <img src="/newImages/home/logo.png" alt="icon" />
                    </div>
                    <h2>Perpstreet</h2>
                  </NextLink>
                  <div className="close flex items-center justify-center" onClick={setFalse}>
                    <svg onClick={setFalse} width="20" height="21" viewBox="0 0 20 21" fill="none">
                      <path
                        d="M15.156 6.46108C15.4 6.217 15.4 5.82127 15.156 5.5772C14.9119 5.33312 14.5162 5.33312 14.2721 5.5772L9.99998 9.8493L5.72787 5.5772C5.4838 5.33312 5.08807 5.33312 4.84399 5.5772C4.59991 5.82127 4.59991 6.217 4.84399 6.46108L9.11609 10.7332L4.54936 15.2999C4.30529 15.544 4.30529 15.9397 4.54936 16.1838C4.79344 16.4279 5.18917 16.4279 5.43325 16.1838L9.99998 11.6171L14.5667 16.1838C14.8108 16.4279 15.2065 16.4279 15.4506 16.1838C15.6947 15.9397 15.6947 15.544 15.4506 15.2999L10.8839 10.7332L15.156 6.46108Z"
                        fill="white"
                        fillOpacity="0.45"
                      />
                    </svg>
                  </div>
                </div>
                <div className="scroll-box flex flex-col flex-1">
                  {menuItems.map((i, index) => (
                    <div className="link" key={i.label}>
                      <>
                        {i.items.length === 0 ? (
                          <NextLink
                            className={`jump-link jump ${
                              activeMenuItem?.href === i?.href ? 'active' : 'default'
                            } row-between ${i.href === '/liquidity' ? 'hot' : ''}`}
                            href={i.href}
                            target={i?.href?.startsWith('https') ? '_blank' : '_self'}
                            onClick={() => {
                              setOpenMenu(-1)
                              setFalse()
                            }}
                          >
                            <div className="pointer">{t(i.label)}</div>
                            {i.items.length > 0 && (
                              <IconNavArrow className={`item ${openMenu === index ? 'open' : 'hide'}`} />
                            )}
                            {i.href === '/liquidity' && <span className="row-center">hot</span>}
                          </NextLink>
                        ) : (
                          <div
                            className={`jump-link jump ${openMenu === index ? 'active' : 'default'} row-between`}
                            onClick={() => {
                              setOpenMenu(index)
                            }}
                          >
                            <div className="pointer">{t(i.label)}</div>
                            {i.items.length > 0 && (
                              <IconNavArrow className={`item ${openMenu === index ? 'open' : 'hide'}`} />
                            )}
                          </div>
                        )}
                      </>
                      {openMenu !== -1 && openMenu === index && (
                        <div className="item-menu">
                          {i.items.map((ele) => (
                            <NextLink
                              className={`row-start ${pathname === ele.href ? 'active' : 'default'} row-start`}
                              href={ele.href}
                              key={ele.href}
                              target={/^http/.test(ele.href) ? '_blank' : '_self'}
                              onClick={() => {
                                setFalse()
                              }}
                            >
                              {t(ele.label as string)}
                              {/^http/.test(ele.href) && <img src="/newImages/_global/icon-jump.svg" alt="icon" />}
                            </NextLink>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* <div>
                  <Button type="solid" className="setting-button" onClick={showSetting}>
                    <div className="flex items-center gap-8">
                      <img src="/newImages/_global/icon-settings.svg" alt="icon" />
                      <span className="f-14">Settings</span>
                    </div>
                  </Button>
                </div> */}
              </div>
            </BurgerMenu>
          </div>
        </div>
      </Nav>
      <Wrapper className="menu-wrapper" $open={openMenu === -1}>
        {/* <div className="circular" /> */}
        {props.children}
      </Wrapper>
    </>
  )

  return (
    <>
      <UikitMenu
        linkComponent={LinkComponent}
        rightSide={
          <>
            <GlobalSettings mode={SettingsMode.GLOBAL} />
            <NetworkSwitcher />
            <UserMenu />
          </>
        }
        chainId={chainId}
        // banner={showPhishingWarningBanner && typeof window !== 'undefined' && <PhishingWarningBanner />}
        banner={null}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        cakePriceUsd={cakePriceUsd}
        links={menuItems}
        subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
        footerLinks={getFooterLinks}
        activeItem={activeMenuItem?.href}
        activeSubItem={activeSubMenuItem?.href}
        buyCakeLabel={t('Buy CAKE')}
        buyCakeLink="https://pancakeswap.finance/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82&chainId=56"
        {...props}
      />
    </>
  )
}

export default Menu
